import React, { FunctionComponent } from 'react'

import { SimpleContainerBox } from '../../../base/components/Container/SimpleBox.tsx'
import Breadcrumb from '../../../base/components/Template/Breadcrumb/Breadcrumb.tsx'
import { tipoArticuloRoutesMap } from '../tipoArticuloRoutes.tsx'
import TipoArticuloListado from './listado/TipoArticuloListado'

interface OwnProps {}

type Props = OwnProps

/**
 * Gestion o paginba principal para gestionar los almacen
 * @constructor
 */
const TipoArticuloGestion: FunctionComponent<Props> = () => {
  return (
    <SimpleContainerBox maxWidth={'md'}>
      <Breadcrumb routeSegments={[tipoArticuloRoutesMap.gestion]} />
      <TipoArticuloListado />
    </SimpleContainerBox>
  )
}

export default TipoArticuloGestion
